import NewspaperTable from './NewspaperTable'

export default NewspaperTable
